import { useCallback } from 'react';
import { useSearchUsersOnPortalQuery } from 'academy-common-lib/__generated__/chirp/com/hubspot/learning/center/assignments/rpc/UserChirpService.hooks';
export const useHubSpotterUsersForAccount = ({
  accountId
}) => {
  const {
    data: usersForAccount,
    loading: usersForAccountLoading,
    error: usersForAccountError,
    refetch
  } = useSearchUsersOnPortalQuery({
    variables: {
      targetPortalId: accountId,
      pageLength: 20,
      offset: {
        cursor: 0
      }
    }
  });
  const refetchUsersForAccount = useCallback(async ({
    query,
    offset
  }) => {
    const results = await refetch({
      targetPortalId: accountId,
      query,
      pageLength: 20,
      offset: {
        cursor: offset
      }
    });
    return results.data;
  }, [accountId, refetch]);
  return {
    usersForAccount,
    usersForAccountLoading,
    usersForAccountError,
    refetchUsersForAccount
  };
};